export interface VehicleDef {
  id: string;
  name: string;
  /** Kenney Car Kit model filename (Model style). */
  model: string;
  /** Relative scale for the blocky builder. */
  length: number;
  width: number;
  height: number;
  /** Short flavour text shown in the lobby. */
  blurb: string;
}

export const VEHICLES: VehicleDef[] = [
  { id: 'car', name: 'Car', model: 'sedan.glb', length: 4, width: 2, height: 1.4, blurb: 'The reliable all-rounder.' },
  { id: 'race', name: 'Race Car', model: 'race.glb', length: 4.4, width: 2, height: 1.1, blurb: 'Low, loud and fast-looking.' },
  { id: 'truck', name: 'Truck', model: 'truck.glb', length: 5, width: 2.2, height: 2, blurb: 'Big cab, big attitude.' },
  { id: 'van', name: 'Van', model: 'van.glb', length: 4.6, width: 2.1, height: 2, blurb: 'Room for all your motivation.' },
  { id: 'taxi', name: 'Taxi', model: 'taxi.glb', length: 4, width: 2, height: 1.5, blurb: 'Meter is running.' },
  { id: 'police', name: 'Police Car', model: 'police.glb', length: 4.2, width: 2, height: 1.5, blurb: 'Pulling over typos.' },
  { id: 'bus', name: 'Bus', model: 'bus.glb', length: 6, width: 2.2, height: 2.4, blurb: 'Everyone aboard.' },
  { id: 'tractor', name: 'Tractor', model: 'tractor.glb', length: 3.6, width: 2, height: 2.2, blurb: 'Slow and steady wins the race. Maybe.' },
  { id: 'kart', name: 'Go-Kart', model: 'kart.glb', length: 2.6, width: 1.6, height: 0.9, blurb: 'Tiny, nimble, zero doors.' },
  { id: 'monster', name: 'Monster Truck', model: 'monster.glb', length: 4.4, width: 2.6, height: 2.6, blurb: 'Wheels bigger than your problems.' },
];

export const DEFAULT_VEHICLE = 'car';

/** Roblox-ish saturated palette (name, hex). Colour-blind friendly ordering: first six are distinct in all common CVD types. */
export const COLOURS: { name: string; hex: string }[] = [
  { name: 'Bright red', hex: '#e53935' },
  { name: 'Bright blue', hex: '#1e88e5' },
  { name: 'Bright yellow', hex: '#fdd835' },
  { name: 'Lime', hex: '#7cb342' },
  { name: 'Orange', hex: '#fb8c00' },
  { name: 'Purple', hex: '#8e24aa' },
  { name: 'Teal', hex: '#00acc1' },
  { name: 'Pink', hex: '#ec407a' },
  { name: 'White', hex: '#f5f5f5' },
  { name: 'Black', hex: '#263238' },
];

export function vehicleById(id: string): VehicleDef {
  return VEHICLES.find((v) => v.id === id) ?? VEHICLES[0]!;
}

export function isValidColour(hex: string): boolean {
  return COLOURS.some((c) => c.hex === hex);
}
